import dayjs from "dayjs";
import { Poll, PollStatus } from "./interfaces";

export const pollStatuses: PollStatus[] = [
  PollStatus.ACTIVE,
  PollStatus.SCHEDULED,
  PollStatus.ENDED,
];

// The status follows from the time window, the backend does not store it
export const getPollStatus = (
  poll: Pick<Poll, "start_time" | "end_time">,
  now = dayjs()
): PollStatus => {
  if (now.isBefore(dayjs(poll.start_time))) return PollStatus.SCHEDULED;
  if (now.isAfter(dayjs(poll.end_time))) return PollStatus.ENDED;
  return PollStatus.ACTIVE;
};
